import {css} from 'lit-element';
export default css`:host([fixed]) :host auro-dropdown::part(trigger){min-height:var(--auro-size-500, 40px);max-height:var(--auro-size-500, 40px)}:host([fixed]) .selectElement-helpText{margin:var(--auro-size-50, 4px) 0;line-height:16px}`;
